module.exports = __webpack_public_path__ + "img/cern.258b7837.png";